import { createSelector } from '@ngrx/store';

import { NewslettersConfigState } from '../../declarations/newsletters-config';

import { ConfigurationState }  from '../index';

import { selectConfigurationState } from './';

export const selectNewslettersConfig = createSelector(
  selectConfigurationState,
  (state: ConfigurationState) => state?.newslettersConfig
);

export const selectNewslettersColorset = createSelector(
  selectNewslettersConfig,
  (state: NewslettersConfigState) => state?.colorset || []
);

export const selectNewslettersFonts = createSelector(
  selectNewslettersConfig,
  (state: NewslettersConfigState) => state?.fonts || []
);

export const selectNewslettersPrimaryColor = createSelector(
  selectNewslettersConfig,
  (state: NewslettersConfigState) => state?.primaryColor
);

export const selectNewslettersSecondaryColor = createSelector(
  selectNewslettersConfig,
  (state: NewslettersConfigState) => state?.secondaryColor
);
